import { render, staticRenderFns } from "./ServiceProduct.vue?vue&type=template&id=2918a01b&"
import script from "./ServiceProduct.vue?vue&type=script&lang=js&"
export * from "./ServiceProduct.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports